import PropTypes from "prop-types";
import React, { Component } from "react";
import {MSpinner, FileList} from "components/Shared";
class Files extends Component {
  constructor(props) {
    super(props);
  }

  render() {
    const { isFetching, files, token } = this.props;

    if (isFetching) {
      return <MSpinner/>;
    }

    if (!files) {
      return <MSpinner/>;
    }

    const fileList = files.attachedFiles || [];

    return (
      <section className="case-header">
        <h4>File Attachments</h4>
        <div className="md-cell md-cell--12">
              <FileList
                fileList = {fileList}
                token = {token}
              />
        </div>
      </section>);
  }
}

Files.propTypes = {
  isFetching: PropTypes.bool.isRequired,
  files: PropTypes.object.isRequired,
  token: PropTypes.string.isRequired,
};

export default Files;